import { Injectable, signal } from "@angular/core";
import { MCDialog } from "@maslul/common-services";

@Injectable({
    providedIn: 'root'
})
export class DialogService {

    dialog = signal<MCDialog>(new MCDialog());
}
